import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventDTO, Page, SearchRequest } from '../model';
import { Crud } from './crud-abstract';

@Injectable({
  providedIn: 'root'
})
export class EventService extends Crud<EventDTO> {
  override baseUrl = 'api/events';

  search(request: SearchRequest): Observable<Page<EventDTO>> {
    return this.http.get<Page<EventDTO>>(`${this.baseUrl}/search`, { params: { ...request } });
  }
}
